"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createConnectorConfigFlags = exports.createMockConnectorOption = exports.createMockConnectorConfig = void 0;
const faker_1 = require("@faker-js/faker");
const common_1 = require("@hum/common");
const __1 = require("..");
const createMockConnectorConfig = (overwrites = {}) => {
    const config = {
        id: faker_1.faker.datatype.number({ min: 1 }),
        connectorType: (0, common_1.randomlySelectObjectValue)(__1.ConnectorType),
        connectorSource: (0, common_1.randomlySelectObjectValue)(__1.ConnectorSource),
        label: '',
        parameters: [
            { label: 'Merchaint Id', fieldName: 'merchant_id' },
            { label: 'Public Key', fieldName: 'public_key' },
            { label: 'Private Key', fieldName: 'private_key' },
        ],
        platformType: (0, common_1.randomlySelectObjectValue)(__1.PlatformType),
        connectionType: (0, common_1.randomlySelectObjectValue)(__1.ConnectionType),
        isBeta: faker_1.faker.datatype.boolean(),
    };
    config.label = config.connectorType;
    Object.assign(config, overwrites);
    return config;
};
exports.createMockConnectorConfig = createMockConnectorConfig;
const createMockConnectorOption = (overwrites = {}) => {
    const config = (0, exports.createMockConnectorConfig)(overwrites);
    return { config };
};
exports.createMockConnectorOption = createMockConnectorOption;
const createConnectorConfigFlags = (configs) => configs.reduce((connectors, config) => (Object.assign(Object.assign({}, connectors), { [`show-${config.connectorType}-${config.connectorSource}-connector`.replace(/_/g, '-')]: {
        enabled: true,
    } })), {});
exports.createConnectorConfigFlags = createConnectorConfigFlags;
//# sourceMappingURL=ConnectorConfig.factory.js.map